export class Service {
  constructor({
    adsPath = "",
    breadcrumb = [],
    meta = [],
    section = "",
    sectionAds = "",
    slug = "",
    template = "",
    title = "",
    titleHeader = "",
    titleHeaderLink = "",
    titleHeaderTag = "h1",
    widthFull = false,
    showGoolgeOneTap,
    autorefresh,
    width100,
    bannersOn,
    enableHeader,
    enableFooter,
    pageType = "",
    bannerLogo = false,
    showTitleHeaderApp = true,
    showMenuApp = true,
    showBreadcrumbApp = true,
    showBannerH1App = true,
    bannerFlotanteOff,
    bannerHorizontalOff,
    showLiveblog,
    showNewsToday,
    customNewsToday = false,
    subheaderEnable = true,
    classService = "",
    cssClass = "",
    idBucket = "",
    latest = true,
    hideSubHeadSectionBox,
    hideSectionScroll = false,
    isTitleHeader = false,
  }) {
    this.adsPath = adsPath;
    this.breadcrumb = breadcrumb;
    this.data = {};
    this.meta = this.parseMeta(meta);
    this.section = section;
    this.sectionAds = sectionAds;
    this.slug = slug;
    this.template = template;
    this.title = title;
    this.titleHeader = titleHeader;
    this.titleHeaderLink = titleHeaderLink;
    this.titleHeaderTag = titleHeaderTag;
    this.widthFull = widthFull;
    this.showGoolgeOneTap = showGoolgeOneTap;
    this.autorefresh = autorefresh;
    this.width100 = width100;
    this.bannersOn = bannersOn;
    this.enableHeader = enableHeader;
    this.enableFooter = enableFooter;
    this.pageType = pageType;
    this.bannerLogo = bannerLogo;
    this.showTitleHeaderApp = showTitleHeaderApp;
    this.showMenuApp = showMenuApp;
    this.showBreadcrumbApp = showBreadcrumbApp;
    this.showBannerH1App = showBannerH1App;
    this.bannerFlotanteOff = bannerFlotanteOff;
    this.bannerHorizontalOff = bannerHorizontalOff;
    this.showLiveblog = showLiveblog;
    this.showNewsToday = showNewsToday;
    this.customNewsToday = customNewsToday;
    this.subheaderEnable = subheaderEnable;
    this.classService = classService;
    this.cssClass = cssClass;
    this.idBucket = idBucket;
    this.latest = latest;
    this.hideSubHeadSectionBox = hideSubHeadSectionBox;
    this.hideSectionScroll = hideSectionScroll;
    this.isTitleHeader = isTitleHeader;
  }

  getAdsPath = () => {
    return this.adsPath;
  };

  setAdsPath = (adsPath) => {
    this.adsPath = adsPath;
  };

  getPageType = () => {
    return this.pageType;
  };

  setPageType = (pageType) => {
    this.pageType = pageType;
  };

  getData = () => {
    return this.data;
  };

  setData = (data) => {
    this.data = data;
  };

  getMeta = () => {
    return this.meta;
  };

  setMeta = (meta) => {
    this.meta = meta;
  };

  getWidthFull = () => {
    return this.widthFull;
  };

  setWidthFull = (widthFull) => {
    this.widthFull = widthFull;
  };

  getCustomNewsToday = () => {
    return this.customNewsToday;
  };

  setCustomNewsToday = (newsToday) => {
    this.customNewsToday = newsToday;
  };

  getSection = () => {
    return this.section;
  };

  setSection = (section) => {
    this.section = section;
  };

  getSectionAds = () => {
    return this.sectionAds;
  };

  setSectionAds = (sectionAds) => {
    this.sectionAds = sectionAds;
  };

  getTemplate = () => {
    return this.template;
  };

  setTemplate = (template) => {
    this.template = template;
  };

  setTitle = (title) => {
    this.title = title;
  };

  getTitle = () => {
    return this.title;
  };

  setTitleHeader = (titleHeader) => {
    this.titleHeader = titleHeader;
  };

  getTitleHeader = () => {
    return this.titleHeader;
  };

  setTitleHeaderLink = (titleHeaderLink) => {
    this.titleHeaderLink = titleHeaderLink;
  };

  getTitleHeaderLink = () => {
    return this.titleHeaderLink;
  };

  setTitleHeaderTag = (titleHeaderTag) => {
    this.titleHeaderTag = titleHeaderTag;
  };

  getTitleHeaderTag = () => {
    return this.titleHeaderTag;
  };

  setBreadcrumb = (breadcrumb) => {
    this.breadcrumb = breadcrumb;
  };

  getBreadcrumb = () => {
    return this.breadcrumb;
  };

  getSlug = () => {
    return this.slug;
  };

  setSlug = (slug) => {
    this.slug = slug;
  };

  getEnableHeader = () => {
    return this.enableHeader;
  };

  setEnableHeader = (enableHeader) => {
    this.enableHeader = enableHeader;
  };

  getEnableFooter = () => {
    return this.enableFooter;
  };

  setEnableFooter = (enableFooter) => {
    this.enableFooter = enableFooter;
  };

  getShowTitleHeaderApp = () => {
    return this.showTitleHeaderApp;
  };

  setShowTitleHeaderApp = (showTitleHeaderApp) => {
    this.showTitleHeaderApp = showTitleHeaderApp;
  };
  
  getShowMenuApp = () => {
    return this.showMenuApp;
  };

  setShowMenuApp = (showMenuApp) => {
    this.showMenuApp = showMenuApp;
  };

  getShowBreadcrumbApp = () => {
    return this.showBreadcrumbApp;
  };

  setShowBreadcrumbApp = (showBreadcrumbApp) => {
    this.showBreadcrumbApp = showBreadcrumbApp;
  };
  
  getShowBannerH1App = () => {
    return this.showBannerH1App;
  };

  setShowBannerH1App = (showBannerH1App) => {
    this.showBannerH1App = showBannerH1App;
  };

  setShowBannerH1App = (subheaderEnable) => {
    this.subheaderEnable = subheaderEnable;
  };

  getclassService = () => {
    return this.classService;
  };
  
  setclassService = (classService) => {
    this.classService = classService;
  }

  getIdBucket = () => {
    return this.idBucket;
  };

  setIdBucket = (idBucket) => {
    this.idBucket = idBucket;
  };

  getLatest = () => {
    return this.latest;
  };

  setLatest = (latest) => {
    this.latest = latest;
  };
  getHideSubHeadSectionBox = () => {
    return this.hideSubHeadSectionBox;
  };

  setHideSubHeadSectionBox = (hideSubHeadSectionBox) => {
    this.hideSubHeadSectionBox = hideSubHeadSectionBox;
  };
  getHideSectionScroll = () => {
    return this.hideSectionScroll;
  };

  setHideSectionScroll = (hideSectionScroll) => {
    this.hideSectionScroll = hideSectionScroll;
  };

  getIsTitleHeader = () => {
    return this.isTitleHeader;
  }

  setIsTitleHeader = (isTitleHeader) => {
    this.isTitleHeader = isTitleHeader;
  }

  parseDataToFront() {
    return {
      adsPath: this.adsPath ?? null,
      breadcrumb: this.breadcrumb ?? null,
      data: this.data ?? null,
      meta: this.meta ?? null,
      section: this.section ?? null,
      sectionAds: this.sectionAds ?? null,
      slug: this.slug ?? null,
      template: this.template ?? null,
      title: this.title ?? null,
      titleHeader: this.titleHeader ?? null,
      titleHeaderLink: this.titleHeaderLink ?? null,
      titleHeaderTag: this.titleHeaderTag ?? null,
      widthFull: this.widthFull ?? null,
      showGoolgeOneTap: this.showGoolgeOneTap ?? true,
      autorefresh: this.autorefresh ?? true,
      width100: this.width100 ?? false,
      bannersOn: this.bannersOn ?? true,
      enableHeader: this.enableHeader ?? true,
      enableFooter: this.enableFooter ?? true,
      pageType: this.pageType ?? null,
      bannerLogo: this.bannerLogo ?? false,
      showTitleHeaderApp: this.showTitleHeaderApp ?? true,
      showMenuApp: this.showMenuApp ?? true,
      showBreadcrumbApp: this.showBreadcrumbApp ?? true,
      showBannerH1App: this.showBannerH1App ?? true,      
      bannerFlotanteOff: this?.bannerFlotanteOff ?? [],
      bannerHorizontalOff: this?.bannerHorizontalOff ?? [],
      showLiveblog: this?.showLiveblog ?? true,
      showNewsToday: this?.showNewsToday ?? true,
      customNewsToday: this?.customNewsToday ?? false,
      subheaderEnable: this?.subheaderEnable ?? true,
      classService: this?.classService ?? "",
      cssClass: this?.cssClass ?? "",
      idBucket: this?.idBucket ?? "",
      latest: this?.latest ?? true,
      hideSubHeadSectionBox: this?.hideSubHeadSectionBox ?? false,
      hideSectionScroll: this?.hideSectionScroll ?? false,
      isTitleHeader: this?.isTitleHeader ?? false,
    };
  }

  parseMeta({
    description = "",
    keywords = "",
    title = "",
    url = "",
    urlImage = "",
    extra = []
  }) {
    return [
      { "http-equiv": "Content-Type", content: "text/html; charset=UTF-8" },
      { name: "viewport", content: "width=device-width, maximum-scale=5" },
      { "http-equiv": "X-UA-Compatible", content: "IE=edge" },
      { name: "description", content: description },
      { name: "keywords", content: keywords },
      { name: "author", content: "Clarin.com" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:image:src",
        content: urlImage ?? "https://www.clarin.com/img/default.svg",
      },
      { name: "twitter:image:alt", content: "clarin.com" },
      { name: "twitter:site", content: "@clarincom" },
      { name: "twitter:creator", content: "@clarin" },
      { name: "twitter:domain", content: "clarin.com" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      {
        property: "og:image",
        content: urlImage ?? "https://www.clarin.com/img/default.svg",
      },
      { property: "og:title", content: title },
      {
        property: "og:url",
        content: `${process.env.NEXT_PUBLIC_DOMAIN_URL}/${url}`,
      },
      { property: "og:description", content: description },
      { property: "fb:pages", content: "156057357762712" },
      { property: "fb:app_id", content: "437491989970687" },
      { property: "og:type", content: "article" },
      { property: "article:section", content: "Clarín - Servicios" },

      ...extra,
    ];
  }

  fetchData = async (url, options = {}) => {
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      return {
        code: 200,
        data: data,
        error: null,
      };
    } catch (error) {
      return {
        code: 500,
        data: null,
        error: error?.message ?? "",
      };
    }
  };

  parseData = () => {};
}
